import { createApp, type Component } from 'vue'

import { createAppI18n } from '../i18n'
import SearchClub from '../player/islands/SearchClub.vue'
import AvailabilityGrid from '../player/islands/AvailabilityGrid.vue'
import BookingCheckout from '../player/islands/BookingCheckout.vue'
import ProfilePreferences from '../player/islands/ProfilePreferences.vue'
import CoachBooking from '../player/islands/CoachBooking.vue'
import NotificationBell from '../player/islands/NotificationBell.vue'
import '../styles/player.css'

const islands: Record<string, Component> = { SearchClub, AvailabilityGrid, BookingCheckout, ProfilePreferences, CoachBooking, NotificationBell }

export function mountIslands(root: ParentNode = document): number {
  const elements = root.querySelectorAll<HTMLElement>('[data-island]')
  let mounted = 0

  elements.forEach((element) => {
    const component = islands[element.dataset.island ?? '']
    if (!component) return

    const props = JSON.parse(element.dataset.props || '{}') as Record<string, unknown>
    createApp(component, props).use(createAppI18n()).mount(element)
    mounted += 1
  })

  return mounted
}

mountIslands()
